export const STORAGE_CONDITION_GET_REQUEST = 'STORAGE_CONDITION_GET_REQUEST';
export const STORAGE_CONDITION_GET_SUCCESS = 'STORAGE_CONDITION_GET_SUCCESS';
export const STORAGE_CONDITION_GET_ERROR = 'STORAGE_CONDITION_GET_ERROR';
export const STORAGE_CONDITION_GET_BY_KEY_REQUEST = 'STORAGE_CONDITION_GET_BY_KEY_REQUEST';
export const STORAGE_CONDITION_GET_BY_KEY_SUCCESS = 'STORAGE_CONDITION_GET_BY_KEY_SUCCESS';
export const STORAGE_CONDITION_GET_BY_KEY_ERROR = 'STORAGE_CONDITION_GET_BY_KEY_ERROR';
export const STORAGE_CONDITION_ADD_REQUEST = 'STORAGE_CONDITION_ADD_REQUEST';
export const STORAGE_CONDITION_ADD_SUCCESS = 'STORAGE_CONDITION_ADD_SUCCESS';
export const STORAGE_CONDITION_ADD_ERROR = 'STORAGE_CONDITION_ADD_ERROR';
export const STORAGE_CONDITION_EDIT_REQUEST = 'STORAGE_CONDITION_EDIT_REQUEST';
export const STORAGE_CONDITION_EDIT_SUCCESS = 'STORAGE_CONDITION_EDIT_SUCCESS';
export const STORAGE_CONDITION_EDIT_ERROR = 'STORAGE_CONDITION_EDIT_ERROR';
export const STORAGE_CONDITION_DELETE_REQUEST = 'STORAGE_CONDITION_DELETE_REQUEST';
export const STORAGE_CONDITION_DELETE_SUCCESS = 'STORAGE_CONDITION_DELETE_SUCCESS';
export const STORAGE_CONDITION_DELETE_ERROR = 'STORAGE_CONDITION_DELETE_ERROR';
